
import { useState, useEffect, useCallback } from 'react';

const testimonials = [
  {
    name: 'Ann Robertson',
    date: '3 weeks ago',
    rating: 5,
    text: 'Have used Beyond Electricity several times for electrical jobs around the house. Today Stephen did an excellent job replacing the bathroom light pull. He was very efficient, professional, and got everything sorted quickly with no fuss. The work was done to a high standard and he left everything clean and tidy afterwards. Really pleased with the service and would definitely recommend him to anyone needing a reliable electrician.'
  },
  {
    name: 'Gobind Mirchandani',
    date: '3 weeks ago',
    rating: 5,
    text: 'Once again Beyond Electrical have been great. Steve is always professional and diligent. I will definitely be using them again.'
  },
  {
    name: 'Stephanie Black',
    date: '3 months ago',
    rating: 5,
    text: 'Looking for work completed regarding external electrics and internet. Stephen was polite, punctual and professional. He took great care in making sure things were as neat as possible and took the time to set up and check to make sure all was working. Would not hesitate to recommend him. The day the work needed finishing was pretty much monsoon weather and he finished the job brilliantly. Very pleased.'
  },
  {
    name: 'Sarah Westwood',
    date: '3 months ago',
    rating: 5,
    text: 'Excellent service. Stephen installed our new lights and added a plug socket. All done to a high standard. Communication was clear throughout. We\'ll happily use him again and recommend.'
  },
  {
    name: 'Richard Bell',
    date: '3 months ago',
    rating: 5,
    text: 'Stephen did a full rewire for us and was very knowledgeable, efficient and tidy.'
  },
  {
    name: 'A D',
    date: '4 months ago',
    rating: 5,
    text: 'Steve was great! He came up with a really smart solution to a tricky problem, got the job done and left without a trace of mess. On top of that really friendly and approachable. Would highly recommend'
  }
];

function GoogleLogo() {
  return (
    <span className="inline-flex items-center gap-0.5 font-bold text-sm">
      <span style={{ color: '#4285F4' }}>G</span>
      <span style={{ color: '#EA4335' }}>o</span>
      <span style={{ color: '#FBBC05' }}>o</span>
      <span style={{ color: '#4285F4' }}>g</span>
      <span style={{ color: '#34A853' }}>l</span>
      <span style={{ color: '#EA4335' }}>e</span>
    </span>
  );
}

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const visibleCount = 3;

  const next = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
      setIsAnimating(false);
    }, 300);
  }, [isAnimating]);

  const prev = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
      setIsAnimating(false);
    }, 300);
  }, [isAnimating]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const getVisible = () => {
    const items = [];
    for (let i = 0; i < visibleCount; i++) {
      items.push(testimonials[(current + i) % testimonials.length]);
    }
    return items;
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-[#0D1F3C] to-[#0A1628] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#FFD700] rounded-full filter blur-3xl animate-pulse"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-4">
            <GoogleLogo />
            <span className="text-gray-400 text-sm font-medium">Reviews</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-3">
            What Our <span className="text-[#FFD700]">Customers Say</span>
          </h2>
          {/* Overall rating bar */}
          <div className="inline-flex items-center gap-3 bg-white/5 border border-[#FFD700]/30 rounded-full px-6 py-2 mt-4">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#FFD700] text-lg"></i>
              ))}
            </div>
            <span className="text-white font-bold text-lg">5.0</span>
            <span className="text-gray-400 text-sm">·</span>
            <GoogleLogo />
            <span className="text-gray-400 text-sm">Verified Reviews</span>
          </div>
        </div>

        {/* Slider */}
        <div className="relative">
          <div
            className={`grid md:grid-cols-3 gap-6 transition-opacity duration-300 ${isAnimating ? 'opacity-0' : 'opacity-100'}`}
          >
            {getVisible().map((testimonial, index) => (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-[#FFD700]/20 hover:border-[#FFD700]/60 transition-all duration-300 flex flex-col"
              >
                {/* Top: Google logo + stars */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-[#FFD700] text-base"></i>
                    ))}
                    <span className="text-[#FFD700] font-bold text-sm ml-1">5</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-google-fill text-base" style={{ color: '#4285F4' }}></i>
                    </div>
                    <GoogleLogo />
                  </div>
                </div>

                {/* Review text */}
                <p className="text-gray-300 text-sm leading-relaxed flex-1 mb-5 italic">
                  &ldquo;{testimonial.text}&rdquo;
                </p>

                {/* Reviewer */}
                <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#FFD700] rounded-full text-[#0A1628] font-bold text-base shrink-0">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{testimonial.name}</p>
                    <p className="text-gray-500 text-xs">{testimonial.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Arrows */}
          <button
            onClick={prev}
            className="absolute -left-5 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#FFD700] text-[#0A1628] rounded-full shadow-lg hover:bg-yellow-400 transition-all duration-200 cursor-pointer whitespace-nowrap hidden md:flex"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            onClick={next}
            className="absolute -right-5 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#FFD700] text-[#0A1628] rounded-full shadow-lg hover:bg-yellow-400 transition-all duration-200 cursor-pointer whitespace-nowrap hidden md:flex"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${i === current ? 'bg-[#FFD700] w-6' : 'bg-white/20'}`}
            />
          ))}
        </div>

        {/* Mobile arrows */}
        <div className="flex justify-center gap-4 mt-6 md:hidden">
          <button onClick={prev} className="w-10 h-10 flex items-center justify-center bg-[#FFD700] text-[#0A1628] rounded-full cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button onClick={next} className="w-10 h-10 flex items-center justify-center bg-[#FFD700] text-[#0A1628] rounded-full cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
